import type { SchemaField } from '../../../../types/schede'
import FieldWrapper from './FieldWrapper'

interface CalculatedFieldProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
}

export default function CalculatedField({ field, value, error }: CalculatedFieldProps) {
  const displayValue = value != null ? String(value) : '-'

  return (
    <FieldWrapper field={field} error={error}>
      <div
        className="w-full px-2 py-1.5 text-sm border rounded"
        style={{
          backgroundColor: 'var(--color-bg-tertiary, #f5f5f5)',
          borderColor: 'var(--color-border)',
          color: 'var(--color-text-primary)',
          opacity: 0.85,
        }}
      >
        {displayValue}
      </div>
      {field.calculation_formula && (
        <p className="text-[10px] mt-0.5" style={{ color: 'var(--color-text-tertiary)' }}>
          Formula: {field.calculation_formula}
        </p>
      )}
    </FieldWrapper>
  )
}
